<template>

</template>

<script>
export default {
  name: 'ToggleMap',
  watch: {
    '$route' () {
      this.covid19Watcher()
      this.reloadElement()
    }
  },
  mounted () {
    this.showElement()
  },
  created () {
    this.covid19Watcher()
  },
  destroyed () {
    this.removeElement()
  },
  methods: {
    covid19Watcher () {
      if (this.$router.history.current.path.indexOf('/democracy-indices') !== -1) {
        this.$store.state.covid19.is_enabled = false
      } else if (this.$router.history.current.path.indexOf('/covid19globalmonitor') !== -1) {
        this.$store.state.covid19.is_enabled = true
      }
    },
    removeElement () {
      let menu = document.getElementById('main-menu')
      if (menu.getElementsByClassName('switch-to').length > 0) {
        let li = menu.getElementsByClassName('switch-to')[0]
        li.remove()
      }
    },
    reloadElement () {
      this.removeElement()
      this.showElement()
    },

    showElement () {
      let menu = document.getElementById('main-menu')
      let elli = document.createElement('li')
      elli.classList.add('switch-to')
      let link = document.createElement('a')
      let block = document.createElement('div')
      block.classList.add('content')
      let linkName = ''

      if (this.$router.history.current.path.indexOf('/covid19globalmonitor') !== -1 || this.$store.state.covid19.is_enabled === true) {
        link.classList.add('to-democraty')
        linkName = 'democracy-indices'
        block.innerHTML = 'Go To Democracy Indices'
      } else if (this.$router.history.current.path.indexOf('/democracy-indices') !== -1 || this.$store.state.covid19.is_enabled === false) {
        link.classList.add('to-covid')
        linkName = 'covid19globalmonitor'
        block.innerHTML = 'go to COVID-19'
      }
      link.href = linkName
      link.append(block)
      elli.append(link)
      menu.appendChild(elli)
    }
  }
}
</script>

<style lang="scss">
@import '~@/components/sass/shared/colors';
.switch-to{

  .to-covid{
    align-items: center;
    background: $covid19;
    color: $white;
    cursor: pointer;
    display: flex; -js-display: flex;
    flex: none;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 15px 30px;
    width:225px;
    text-decoration: none;

    .content::before{
      display:inline-block;
      content:'';
      height:25px;
      width:25px;
      position: absolute;
      top:2px;
      left:0;
      background-size: 100% 100%;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' class='icon'%3e%3cg id='Group_38' data-name='Group 38' transform='translate(-945.083 -83.394)'%3e%3cpath id='Path_107' data-name='Path 107' d='M957.414,84.7a1.481,1.481,0,0,0,.067.649h0a12.568,12.568,0,0,1,.4,3.734,1.86,1.86,0,0,1-1.194,1.377c-.155.026-.307.061-.458.1-.034.009-.069.014-.1.024s-.064.022-.1.031a5.357,5.357,0,0,0-.686.253,2.016,2.016,0,0,1-1.592-.561,12.313,12.313,0,0,1-1.541-3.3,1.494,1.494,0,1,0-2.15,1.5l0,0a12.576,12.576,0,0,1,2.925,2.361,1.86,1.86,0,0,1,.14,1.8c-.1.133-.183.27-.265.41-.018.03-.038.059-.055.089s-.031.061-.047.091a5.524,5.524,0,0,0-.306.662,2.01,2.01,0,0,1-1.525.73,12.319,12.319,0,0,1-3.422-1.245A1.493,1.493,0,1,0,947.041,96v0a12.589,12.589,0,0,1,3.734-.4,1.86,1.86,0,0,1,1.378,1.194c.026.155.061.308.1.46.008.033.014.067.023.1s.022.066.032.1a5.324,5.324,0,0,0,.252.684,2.177,2.177,0,0,1-.431,1.47,12.778,12.778,0,0,1-2.734,1.121,1.493,1.493,0,1,0,1.5,2.15l0,0a13.029,13.029,0,0,1,1.817-2.479,1.954,1.954,0,0,1,1.648-.042c.133.1.27.183.41.266.03.018.058.038.088.055s.062.031.092.048a5.464,5.464,0,0,0,.661.3,2.011,2.011,0,0,1,.73,1.525,12.318,12.318,0,0,1-1.245,3.422,1.474,1.474,0,0,0-.313.736,1.493,1.493,0,1,0,2.9-.279h0a12.587,12.587,0,0,1-.4-3.734,1.86,1.86,0,0,1,1.194-1.377c.155-.027.308-.061.46-.1.034-.009.067-.014.1-.024s.066-.022.1-.031a5.372,5.372,0,0,0,.685-.253,2.177,2.177,0,0,1,1.47.431,12.784,12.784,0,0,1,1.12,2.734,1.494,1.494,0,1,0,2.15-1.5l0,0a13.064,13.064,0,0,1-2.479-1.817,1.957,1.957,0,0,1-.042-1.648c.1-.133.183-.271.266-.411.017-.029.037-.058.055-.088s.031-.062.047-.092a5.393,5.393,0,0,0,.3-.661,2.013,2.013,0,0,1,1.526-.73,12.31,12.31,0,0,1,3.421,1.245,1.478,1.478,0,0,0,.737.313,1.493,1.493,0,1,0-.28-2.9v0a12.589,12.589,0,0,1-3.734.4,1.862,1.862,0,0,1-1.377-1.194c-.026-.155-.061-.308-.1-.46-.008-.033-.014-.067-.023-.1s-.022-.066-.032-.1a5.445,5.445,0,0,0-.252-.685,2.177,2.177,0,0,1,.431-1.47,12.785,12.785,0,0,1,2.733-1.12,1.477,1.477,0,0,0,.742-.3,1.493,1.493,0,1,0-2.246-1.85l0,0a13.086,13.086,0,0,1-1.817,2.479,1.957,1.957,0,0,1-1.648.042c-.133-.1-.27-.182-.409-.265-.03-.018-.059-.038-.09-.056s-.061-.03-.091-.047a5.368,5.368,0,0,0-.662-.305,2.013,2.013,0,0,1-.73-1.526,12.317,12.317,0,0,1,1.245-3.421,1.491,1.491,0,1,0-2.65-1.106Zm.4,13.8a1.175,1.175,0,1,1,1.649.205A1.175,1.175,0,0,1,957.81,98.5Zm-1.158-1.489a1.67,1.67,0,1,1,.292-2.344A1.67,1.67,0,0,1,956.652,97.011Zm2.956-1.439a.835.835,0,1,1,.146-1.172A.835.835,0,0,1,959.608,95.573Z' transform='translate(0)' fill='%23fff'%3e%3c/path%3e%3c/g%3e%3c/svg%3e");
    }
  }
  .to-democraty{
    text-decoration: none;
    background: $covid19;
    color: $white;
    cursor: pointer;
    display: flex; -js-display: flex;
    flex: none;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 15px 0;
    width:225px;
  }
  .content {
    flex: 1 1 auto;
    padding: 4px 1em 4px;
    text-transform: uppercase;
    position: relative;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/shared/misc/ToggleMap.vue